import { render } from "./ApplicationsView.vue?vue&type=template&id=38d666a2&scoped=true"
import script from "./ApplicationsView.vue?vue&type=script&lang=js"
export * from "./ApplicationsView.vue?vue&type=script&lang=js"

import "./ApplicationsView.vue?vue&type=style&index=0&id=38d666a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d666a2"],['__file',"src/views/ApplicationsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38d666a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38d666a2', __exports__)) {
    api.reload('38d666a2', __exports__)
  }
  
  module.hot.accept("./ApplicationsView.vue?vue&type=template&id=38d666a2&scoped=true", () => {
    api.rerender('38d666a2', render)
  })

}


export default __exports__